import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import { bulkRefreshSections, pluralizeObject } from '@helpers/show_page_helpers';
import { BFLoader } from '@components/common/loader/main';
import renderModal from '../modals/renderModal';

class BulkMergeModal extends React.Component {
  state = {
    destinationAssetKey: this.props.selectedAssetsData[0].id,
    destinationAssetName: this.props.selectedAssetsData[0].attributes.name,
    disableSubmitButton: false,
    isLoading: false,
    showConfirmation: false
  }

  componentWillUnmount() {
    this.props.closeModal();
  }

  buildDataBody = () => (
    { data: {
      asset_keys: Array.from(this.props.selectedAssetKeys),
      bulk_merge: {
        destination_asset_key: this.state.destinationAssetKey
      } } }
  )

  mergeAssets = () => {
    this.setState({ disableSubmitButton: true, isLoading: true });

    const assetQtyObject = pluralizeObject(this.props.selectedAssetKeys);
    const assetCopy = assetQtyObject.plural ? t('Assets') : t('Asset');

    $.ajax({
      type: "PUT",
      url: '/api/v4/bulk_actions/assets/merge',
      contentType: "application/json",
      data: JSON.stringify(this.buildDataBody()),
      context: this,
      headers: { Authorization: `Bearer ${BF_Token}` },
      success: () => {
        BF.fx.updateAssetPageCount((assetQtyObject.qty - 1), false);
        this.props.addRemoveSelected([this.state.destinationAssetKey]); // remove merged assets from selectedAssetKeys
        bulkRefreshSections(this.props.selectedAssetKeys);
        this.props.closeModal();
        Notify.create({
          title: `${assetQtyObject.qty} ${assetCopy} ${t('merged!')}`,
          type: 'success'
        });
      },
      error: () => {
        this.setState({ disableSubmitButton: false, isLoading: false });
        Notify.create({
          title: `${t('An error occured while merging')} ${assetQtyObject.qty} ${assetCopy}. ${t('Please try again.')}`,
          type: 'error'
        });
      }
    });
  }

  createOptionsForSelect(options) {
    return options.map((asset) => ({ value: asset.id, label: `${asset.attributes.name} (${asset.attributes.extension})` }));
  }

  renderMerge() {
    if (this.state.showConfirmation) { return null; }

    const { destinationAssetKey, disableSubmitButton } = this.state;
    const assetQtyObject = pluralizeObject(this.props.selectedAssetKeys);
    const assetCopy = assetQtyObject.plural ? t('assets') : t('asset');

    return (
      <>
        <div className="modal-content-wrapper__header">
          <span className="bff-merge icon" aria-hidden="true" />
          <h2 className="modal-title">{t('Bulk Merge')}</h2>
        </div>
        <div className="modal-content-wrapper__body">
          <h3 className="body-title">{t('Merge')}
            <span className="bold-text">{assetQtyObject.qty} {assetCopy}</span>
            {t('into:')}
          </h3>
          <div className="modal-row">
            <Select
              options={this.createOptionsForSelect(this.props.selectedAssetsData)}
              onChange={(option) => this.setState({
                destinationAssetKey: option.value,
                destinationAssetName: option.label
              })}
              placeholder={t('Select asset to merge other assets into')}
              value={destinationAssetKey}
              closeOnSelect
              clearable={false}
            />
          </div>
          <p className="merge-copy">
            {t('Merging assets will combine all attachments, tags, & custom fields.')}
          </p>
          <div className="button-container">
            <button
              className="button tertiary sm t-close-modal"
              onClick={this.props.closeModal}
              type="button"
            >
              {t('Cancel')}
            </button>
            <button
              className="button sm primary t-confirm-modal"
              onClick={() => this.setState({ showConfirmation: true })}
              disabled={disableSubmitButton}
              type="button"
            >
              {t('Merge')}
            </button>
          </div>
        </div>
      </>
    );
  }

  renderConfirmation() {
    if (!this.state.showConfirmation) { return null; }

    const { destinationAssetName, disableSubmitButton, isLoading } = this.state;
    const assetQtyObject = pluralizeObject(this.props.selectedAssetKeys);
    const assetCopy = assetQtyObject.plural ? t('assets') : t('asset');
    const loaderActive = isLoading ? 'loader-active' : '';

    return (
      <React.Fragment>
        <div className={`modal-content-wrapper__header ${loaderActive}`}>
          <span className="bff-warning icon" aria-hidden="true" />
          <BFLoader />
          <h2 className="modal-title">{t('Bulk Merge Confirmation')}</h2>
        </div>
        <div className="modal-content-wrapper__body">
          <div>
            <p className="merge-copy">{t('Are you sure you want to permanently merge')}
              <span className="bold-text">{assetQtyObject.qty} {assetCopy}</span>
              {`${t('into')} ${destinationAssetName}?`}
            </p>
            <p className="merge-copy">{t('This action cannot be undone!')}</p>
          </div>
          <div className="button-container">
            <button
              className="button tertiary sm t-close-modal"
              onClick={this.props.closeModal}
              type="button"
            >
              {t('Cancel')}
            </button>
            <button
              className="button sm primary t-confirm-modal"
              disabled={disableSubmitButton}
              onClick={this.mergeAssets}
              type="button"
            >
              {t('Merge')}
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }

  render() {
    return (
      <div className="modal-content-wrapper bulk-merge-modal">
        {this.renderMerge()}
        {this.renderConfirmation()}
      </div>
    );
  }
}

BulkMergeModal.propTypes = {
  addRemoveSelected: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  selectedAssetsData: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  })).isRequired,
  selectedAssetKeys: PropTypes.instanceOf(Set).isRequired,
};

const ModalComponent = renderModal(BulkMergeModal, 'BulkMergeModal');
export default ModalComponent;
